<template>
    <div class="row">
        <div class="col-md-2 col" v-click-outside='closeNumsHint'>
            <input 
                type="text" 
                placeholder="№ Акта" 
                class="form-control" 
                v-model='act_num' 
                @focus='searchInputFocus'
                
                @input='inputActNum'
                @keydown.enter='closeNumsHint(); search();'
            />
            <ul class="acts_nums" v-show='display_nums_hint'>
                <li 
                    v-for='num in similar_nums' 
                    :key='num.num' 
                    @click='selectActNum(num.num)'
                    v-text='num.num' 
                    :class='{"selected": isNumIsSelected(num.num)}'
                />
            </ul>
        </div>
        <div class="col-md-3 col text-left">
            <datepicker
                v-model='date'
                placeholder='Дата размещения'
                format='dd.MM.yyyy'
                class='datepicker-nums'
            ></datepicker>

            <button class="btn btn-default small-button search-button" @click='search' :disabled='searchButtonDisabled'>
                Поиск <i class='fa fa-spinner fa-spin' v-if='acts_is_loading'></i>
            </button>
        </div>
        <div class="col-md-6 col">
            <div class="selected_nums_wrap">
                <span v-for='(num, index) in acts_nums_to_search' class='num_to_search' :key='num + index'>
                    {{ num }}
                    <span class="delete_num" @click='deleteNum(num)'>x</span>
                </span>
                <span style='opacity: 0'>0</span> <!-- Нужно для исправления загадочного бага с изменением ширины последнего блока с номером -->
            </div>
        </div>
    </div>
</template>

<script>
    import {datepicker} from 'vue-strap'

    export default {
        name: "actsNumsSelector",
        data: function () {
            return {
                display_nums_hint: false,
                act_num: '',
                acts_nums_to_search: [],
                date: '',
                similar_nums: [],
                no_lose_focus: false,
                year: null
            }
        },
        props: {
            acts_is_loading: {
                type: Boolean,
                default: false
            },
            acts_nums: {
                type: Array,
                required: true
            }
        },
        components: {
            datepicker
        },
        computed: {
            searchButtonDisabled() {
                if(this.acts_is_loading)
                    return true
                if(this.date.length == 0) {
                    return this.acts_nums_to_search.length == 0
                } else {
                    return false
                }
                
            }
        },
        methods: {
            isNumIsSelected (num) {
                return this.acts_nums_to_search.includes(num)
            },
            search () {
                this.$emit('change', {nums: this.acts_nums_to_search, date: this.date})
                this.$emit('search')
            },
            searchInputFocus () {
                this.inputActNum()

                if(this.similar_nums.length)
                    this.display_nums_hint = true
            },
            inputActNum (e) {
                if(!this.act_num)
                    return false

                this.similar_nums = []
                this.display_nums_hint = false
                for(let num of this.acts_nums) {
                    if(this.similar_nums.length > 20)
                        break

                    if(num.num.includes(this.act_num))
                        this.similar_nums.push(num)
                }

                if(this.similar_nums.length)
                    this.display_nums_hint = true
                
            },
            selectActNum (num) {
                if(this.isNumIsSelected(num)) {
                    this.deleteNum(num)
                } else {
                    this.acts_nums_to_search.push(num)
                }
                /*
                this.act_num_to_search = num
                this.$emit('change', this.acts_nums_to_search)
                this.display_nums_hint = false*/
            },
            closeNumsHint () {
                this.display_nums_hint = false
            },
            deleteNum (num) {
                this.acts_nums_to_search = this.acts_nums_to_search.filter(e => e != num)
            }
        }
    }
</script>

<style>
.datepicker-nums > .datepicker-input {
    height: 24px !important;
    padding: 2px !important;
}
</style>

<style scoped>
    .text-left {
        text-align: left;
    }

    .form-control {
        height: 24px;
    }

    .datepicker-nums {
        display: inline-block;
        margin: 0;
        padding: 0;
        border: none;
        max-width: 125px;
    }

    .acts_nums {
        width: 87%;
        position: absolute;
        z-index: 1000;
        top: 24px;
        border: 1px solid #aaa;
        list-style-type: none;
        margin: 0;
        padding: 0;
    }

    .acts_nums li {
        padding: 3px 5px;
        font-size: 15px;
        text-align: left;
        border-bottom: 1px solid #ccc;
        background: #fff;
    }

    .acts_nums li.selected {
        background: skyblue;
    }

    .acts_nums li:hover {
        cursor: pointer;
        background: #daf2ff;
        /*background: #b4ffd7;*/
    }

    .acts_nums li:last-child {
        border-bottom: none;
    }

    .selected_nums_wrap {
        text-align: left;
        height: auto;
        line-height: 24px;
    }

    .search-button {
        vertical-align: top;
    }

    .num_to_search {
            margin-right: 7px;
            background: #bee5f4;
            border-radius: 12px;
            position: relative;
            padding: 0px 17px 0px 10px;
            user-select: none;
            display: inline-block;
            margin: 0 7px 10px 0;
    }

    .delete_num {
        background: #bababa;
        height: 14px;
        width: 14px;
        position: absolute;
        top: 2px;
        right: 1px;
        text-align: center;
        line-height: 12px;
        border-radius: 50%;
        cursor: pointer;
    }

    .delete_num:hover {
        background: #a2c5d2;
    }
</style>


// WEBPACK FOOTER //
// actsNumsSelector.vue?17c1fa0b